import React from "react";
import {FaJs, FaNodeJs, FaReact, FaHtml5, FaCss3 } from "react-icons/fa";
import {  FooterContainer, FooterWrap, FooterLinksContainer,
FooterLinksWrapper, FooterLinkItems, FooterLinkTitle,
FooterLink} from './TechStackElements';

import {ReactComponent as Express} from "../../Images/express.svg";
import {ReactComponent as MongoDb} from "../../Images/mongodb.svg";
import {ReactComponent as MySql} from "../../Images/mysql.svg";
import {ReactComponent as TypeScript } from "../../Images/typescript.svg";

const TechStackInfo = () => {
    return(
        <FooterContainer className = "about">
            <FooterWrap>
                <FooterLinksContainer>
                  <FooterLinksWrapper>
                  <FooterLinkItems>
                          <FooterLinkTitle>Programming Languages</FooterLinkTitle>
                              <FooterLink ><FaJs /> &emsp;JavaScript</FooterLink>
                              <FooterLink ><TypeScript />&emsp;TypeScript</FooterLink>
                      </FooterLinkItems>
                      <FooterLinkItems>
                          <FooterLinkTitle>Front-end Technologies</FooterLinkTitle>
                              <FooterLink ><FaHtml5/> &emsp;HTML</FooterLink>
                              <FooterLink ><FaCss3/>&emsp; CSS</FooterLink>
                              <FooterLink ><FaJs /> &emsp;JavaScript</FooterLink>
                              <FooterLink > <FaReact />&emsp;React</FooterLink>
                      </FooterLinkItems>
                     
                      </FooterLinksWrapper> 
                      <FooterLinksWrapper>
                      <FooterLinkItems>
                          <FooterLinkTitle>Back-end Technologies</FooterLinkTitle>
                              <FooterLink><FaNodeJs />&emsp;Node JS</FooterLink>
                              <FooterLink><Express />&emsp;Express</FooterLink>
                      </FooterLinkItems>
                      <FooterLinkItems>
                          <FooterLinkTitle>Databases</FooterLinkTitle>
                          <br/>
                              <FooterLink ><MySql /> &emsp;SQL</FooterLink>
                              <FooterLink ><MongoDb /> &emsp;MongoDB</FooterLink>
                      </FooterLinkItems>
                      </FooterLinksWrapper> 
                </FooterLinksContainer>
            </FooterWrap>
        </FooterContainer>
    )
}

export default TechStackInfo;